var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.animals),function(animal){return _c('li',[_vm._v("\n            "+_vm._s(animal.name)+"\n        ")])})),_vm._v(" "),_c('datatable',{attrs:{"resource_url":_vm.resource_url},on:{"update":_vm.updateResource}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e04a640","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatable.vue
// module id = null
// module chunks = 